// those helpers cannot be together with the actual routes
// because that creates circular dependencies with some components
const CHAT_LIST_HASH = '#chat_list'
const CHAT_HASH = '#chat'
const MEMBER_CHAT_SCOPE = 'me'

function isMemberChatScope(route) {
  return route.params.chatScope === MEMBER_CHAT_SCOPE
}

function isPublisherChatScope(route) {
  return !isMemberChatScope(route)
}

function chatScopePath(chatScope) {
  return `/${chatScope}${CHAT_LIST_HASH}`
}

function publicationChatPath(route, publication) {
  return `/${route.params.chatScope}/${publication.subdomain}${CHAT_HASH}`
}

function memberChatPath(route, member) {
  return `/${route.params.chatScope}/${member.id}${CHAT_HASH}`
}

export {
  isMemberChatScope,
  isPublisherChatScope,
  chatScopePath,
  publicationChatPath,
  memberChatPath,
  CHAT_LIST_HASH,
  CHAT_HASH,
  MEMBER_CHAT_SCOPE
}
